import {createBrowserHistory} from 'history';

const history = createBrowserHistory({
  basename: '/manager/',
});
export default history;
